import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e274f95")

_pushScopeId("data-v-3e274f95")
const _hoisted_1 = { class: "collect-data-box" }
const _hoisted_2 = { class: "collect-header" }
const _hoisted_3 = {
  key: 0,
  style: {"position":"relative","width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { style: {"display":"inline-block","margin":"10% auto 0 auto"} }, null, -1)
const _hoisted_5 = { style: {"padding":"8px 0px"} }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "打开成员码", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { style: {"margin-bottom":"30px"} }, null, -1)
const _hoisted_8 = { style: {"padding":"8px 0px"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "扫一扫成员码", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "group-title-item" }, "信息采集", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "公斤", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "mmol/L", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "mmHg", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "mmHg", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" SpO")
const _hoisted_17 = /*#__PURE__*/_createVNode("sub", null, "2", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "%", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "bpm", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "%", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "group-title-item" }, "备注", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "group-title-item" }, "最近一次检测结果", -1)
const _hoisted_23 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "公斤", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "mmol/L", -1)
const _hoisted_26 = { style: {"color":"burlywood"} }
const _hoisted_27 = /*#__PURE__*/_createVNode("sub", null, "收缩压", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "mmHg", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_30 = { style: {"color":"burlywood"} }
const _hoisted_31 = /*#__PURE__*/_createVNode("sub", null, "舒张压", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "mmHg", -1)
const _hoisted_33 = { style: {"color":"burlywood"} }
const _hoisted_34 = /*#__PURE__*/_createVNode("sub", null, [
  /*#__PURE__*/_createTextVNode("SpO"),
  /*#__PURE__*/_createVNode("sub", null, "2")
], -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "%", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_37 = { style: {"color":"burlywood"} }
const _hoisted_38 = /*#__PURE__*/_createVNode("sub", null, "PR", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "bpm", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_41 = { style: {"color":"burlywood"} }
const _hoisted_42 = /*#__PURE__*/_createVNode("sub", null, "PI", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "value-unit" }, "%", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("svg", {
  t: "1678349532457",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3757",
  width: "60",
  height: "60"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M819.2 0H204.8C129.706667 0 68.266667 61.44 68.266667 136.533333v750.933334c0 75.093333 61.44 136.533333 136.533333 136.533333h614.4c75.093333 0 136.533333-61.44 136.533333-136.533333V136.533333c0-75.093333-61.44-136.533333-136.533333-136.533333zM640 230.4H768c18.773333 0 34.133333 15.36 34.133333 34.133333s-15.36 34.133333-34.133333 34.133334h-128c-18.773333 0-34.133333-15.36-34.133333-34.133334s15.36-34.133333 34.133333-34.133333z m-63.146667 157.013333H768c18.773333 0 34.133333 15.36 34.133333 34.133334s-15.36 34.133333-34.133333 34.133333H575.146667c-18.773333 0-34.133333-15.36-34.133334-34.133333s15.36-34.133333 35.84-34.133334zM221.866667 261.12c0-35.84 29.013333-66.56 66.56-66.56h128c35.84 0 66.56 29.013333 66.56 66.56v128c0 35.84-29.013333 66.56-66.56 66.56h-128c-35.84 0-66.56-29.013333-66.56-66.56v-128zM803.84 785.066667h-131.413333c-5.12 0-11.946667-1.706667-17.066667-5.12l-3.413333-1.706667-34.133334-25.6-76.8 128c-6.826667 10.24-17.066667 17.066667-29.013333 17.066667s-22.186667-5.12-29.013333-15.36l-1.706667-3.413334-90.453333-187.733333-42.666667 78.506667c-5.12 10.24-15.36 17.066667-25.6 17.066666h-98.986667c-18.773333 0-34.133333-15.36-34.133333-34.133333 0-17.066667 13.653333-32.426667 30.72-34.133333H298.666667l64.853333-119.466667c5.12-10.24 17.066667-17.066667 29.013333-17.066667s23.893333 5.12 30.72 15.36l1.706667 3.413334 90.453333 191.146666 63.146667-105.813333c10.24-15.36 30.72-20.48 46.08-11.946667l3.413333 1.706667 56.32 40.96h116.053334c17.066667 0 32.426667 13.653333 34.133333 30.72v3.413333c0 17.066667-13.653333 30.72-30.72 34.133334z",
    fill: "#bfbfbf",
    "p-id": "3758"
  })
], -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 未录入信息 ")
const _hoisted_46 = { style: {"padding":"16px"} }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 关闭 ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_tabs = _resolveComponent("van-tabs")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_form = _resolveComponent("van-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        "before-change": _ctx.onTabsBeforeChange,
        onChange: _ctx.onTabsChange,
        active: _ctx.activeTab,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event)),
        animated: "",
        "line-width": "calc(100% / 2)",
        color: "rgb(159, 102, 204)",
        "title-active-color": "rgb(159, 102, 204)",
        sticky: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_van_tab, {
            title: "自己录入信息",
            name: "yourselfEntry"
          }),
          _createVNode(_component_van_tab, {
            title: "代为录入信息",
            name: "agencyEntry"
          }, {
            default: _withId(() => [
              (_ctx.tabsStateData.agencyEntry.showInitPage)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4,
                    (_ctx.activeTab === 'agencyEntry')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_van_row, { gutter: "20" }, {
                            default: _withId(() => [
                              _createVNode(_component_van_col, {
                                span: "18",
                                offset: "3"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_van_button, {
                                    block: "",
                                    type: "default",
                                    color: "rgb(159, 102, 204)",
                                    plain: "",
                                    onClick: _ctx.openMemberQRCode,
                                    style: {"height":"auto"}
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", _hoisted_5, [
                                        _createVNode(_component_van_icon, {
                                          name: "qr",
                                          size: "106px"
                                        }),
                                        _hoisted_6
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_7,
                          _createVNode(_component_van_row, { gutter: "20" }, {
                            default: _withId(() => [
                              _createVNode(_component_van_col, {
                                span: "18",
                                offset: "3"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_van_button, {
                                    block: "",
                                    type: "primary",
                                    color: "rgb(159, 102, 204)",
                                    onClick: _ctx.scanMemberQRCode,
                                    style: {"height":"auto"}
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", _hoisted_8, [
                                        _createVNode(_component_van_icon, {
                                          name: "scan",
                                          size: "106px"
                                        }),
                                        _hoisted_9
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["before-change", "onChange", "active"])
    ]),
    (_ctx.currentMemberId != null)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
            default: _withId(() => [
              _createVNode(_component_van_cell_group, { inset: "" }, {
                default: _withId(() => [
                  _createVNode(_component_van_field, {
                    "input-align": "right",
                    modelValue: _ctx.form.memberName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.memberName = $event)),
                    label: "姓名",
                    placeholder: "姓名",
                    readonly: "",
                    "aria-readonly": "true"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_cell_group, { inset: "" }, {
                title: _withId(() => [
                  _hoisted_11
                ]),
                default: _withId(() => [
                  _createVNode(_component_van_field, {
                    type: "number",
                    "input-align": "right",
                    modelValue: _ctx.form.weight,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.weight = $event)),
                    label: "体重",
                    placeholder: "体重"
                  }, {
                    extra: _withId(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    type: "number",
                    "input-align": "right",
                    modelValue: _ctx.form.bloodSugar,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.bloodSugar = $event)),
                    label: "血糖",
                    placeholder: "血糖"
                  }, {
                    extra: _withId(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    "input-align": "right",
                    "label-width": "3em",
                    label: "血压"
                  }, {
                    input: _withId(() => [
                      _createVNode("div", null, [
                        _createVNode(_component_van_field, {
                          rules: [{ name: 'systolicBloodPressure', validator: _ctx.validatorFieldByBloodPressure }],
                          type: "number",
                          "input-align": "right",
                          modelValue: _ctx.form.bloodPressure.systolicBloodPressure,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.bloodPressure.systolicBloodPressure = $event)),
                          label: "收缩压",
                          placeholder: "请输入高压"
                        }, {
                          extra: _withId(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }, 8, ["rules", "modelValue"]),
                        _createVNode(_component_van_field, {
                          rules: [{ name: 'diastolicPressure', validator: _ctx.validatorFieldByBloodPressure }],
                          type: "number",
                          "input-align": "right",
                          modelValue: _ctx.form.bloodPressure.diastolicPressure,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.bloodPressure.diastolicPressure = $event)),
                          label: "舒张压",
                          placeholder: "请输入低压"
                        }, {
                          extra: _withId(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["rules", "modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_field, {
                    "input-align": "right",
                    "label-width": "3em",
                    label: "血氧"
                  }, {
                    input: _withId(() => [
                      _createVNode(_component_van_row, { gutter: "20" }, {
                        default: _withId(() => [
                          _createVNode(_component_van_col, { span: "24" }, {
                            default: _withId(() => [
                              _createVNode(_component_van_field, {
                                rules: [{ name: 'SpO2', validator: _ctx.validatorFieldByBloodOxygen }],
                                type: "number",
                                "input-align": "right",
                                modelValue: _ctx.form.bloodOxygen.SpO2,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.bloodOxygen.SpO2 = $event)),
                                label: "SpO2",
                                placeholder: "SpO2（血氧饱和度）"
                              }, {
                                label: _withId(() => [
                                  _hoisted_16,
                                  _hoisted_17
                                ]),
                                extra: _withId(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              }, 8, ["rules", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, { span: "24" }, {
                            default: _withId(() => [
                              _createVNode(_component_van_field, {
                                type: "number",
                                "input-align": "right",
                                modelValue: _ctx.form.bloodOxygen.PR,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.bloodOxygen.PR = $event)),
                                label: "PR",
                                placeholder: "PR（脉率）"
                              }, {
                                extra: _withId(() => [
                                  _hoisted_19
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, { span: "24" }, {
                            default: _withId(() => [
                              _createVNode(_component_van_field, {
                                type: "number",
                                "input-align": "right",
                                modelValue: _ctx.form.bloodOxygen.PI,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.bloodOxygen.PI = $event)),
                                label: "PI",
                                placeholder: "PI（血流灌注指数）"
                              }, {
                                extra: _withId(() => [
                                  _hoisted_20
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_van_cell_group, { inset: "" }, {
                title: _withId(() => [
                  _hoisted_21
                ]),
                default: _withId(() => [
                  _createVNode(_component_van_field, {
                    "input-align": "left",
                    modelValue: _ctx.form.remark,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.remark = $event)),
                    rows: "3",
                    maxlength: "1000",
                    "show-word-limit": "",
                    autosize: { maxHeight: 120 },
                    type: "textarea",
                    placeholder: "请输入备注说明信息"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_cell_group, { inset: "" }, {
                title: _withId(() => [
                  _hoisted_22,
                  (_ctx.newestMemberData.createTime)
                    ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.newestMemberData.createTime), 1))
                    : _createCommentVNode("", true)
                ]),
                default: _withId(() => [
                  (_ctx.newestMemberData._rawData && _ctx.newestMemberData._rawData.length > 0)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_van_field, {
                          "input-align": "right",
                          label: "体重",
                          "label-width": "3em"
                        }, {
                          input: _withId(() => [
                            _createVNode(_component_van_cell, { style: {"padding":"0"} }, _createSlots({ _: 2 }, [
                              (_ctx.newestMemberData.deviceDatas['5']?.value)
                                ? {
                                    name: "title",
                                    fn: _withId(() => [
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['5']?.value)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_24
                                    ])
                                  }
                                : {
                                    name: "title",
                                    fn: _withId(() => [
                                      _createVNode("span", { class: "value-unit" }, "未检测")
                                    ])
                                  }
                            ]), 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_field, {
                          "input-align": "right",
                          label: "血糖",
                          "label-width": "3em"
                        }, {
                          input: _withId(() => [
                            _createVNode(_component_van_cell, { style: {"padding":"0"} }, _createSlots({ _: 2 }, [
                              (_ctx.newestMemberData.deviceDatas['1']?.value)
                                ? {
                                    name: "title",
                                    fn: _withId(() => [
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['1']?.value)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_25
                                    ])
                                  }
                                : {
                                    name: "title",
                                    fn: _withId(() => [
                                      _createVNode("span", { class: "value-unit" }, "未检测")
                                    ])
                                  }
                            ]), 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_field, {
                          "input-align": "right",
                          label: "血压",
                          "label-width": "3em"
                        }, {
                          input: _withId(() => [
                            _createVNode(_component_van_cell, { style: {"padding":"0"} }, _createSlots({ _: 2 }, [
                              (_ctx.newestMemberData.deviceDatas['2']?.value)
                                ? {
                                    name: "title",
                                    fn: _withId(() => [
                                      _withDirectives(_createVNode("span", _hoisted_26, [
                                        _hoisted_27
                                      ], 512), [
                                        [_vShow, _ctx.newestMemberData.deviceDatas['2']?.value.systolicBloodPressure]
                                      ]),
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['2']?.value.systolicBloodPressure)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_28,
                                      _hoisted_29,
                                      _withDirectives(_createVNode("span", _hoisted_30, [
                                        _hoisted_31
                                      ], 512), [
                                        [_vShow, _ctx.newestMemberData.deviceDatas['2']?.value.diastolicPressure]
                                      ]),
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['2']?.value.diastolicPressure)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_32
                                    ])
                                  }
                                : {
                                    name: "title",
                                    fn: _withId(() => [
                                      _createVNode("span", { class: "value-unit" }, "未检测")
                                    ])
                                  }
                            ]), 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_field, {
                          "input-align": "right",
                          label: "血氧",
                          "label-width": "3em"
                        }, {
                          input: _withId(() => [
                            _createVNode(_component_van_cell, { style: {"padding":"0"} }, _createSlots({ _: 2 }, [
                              (_ctx.newestMemberData.deviceDatas['3']?.value)
                                ? {
                                    name: "title",
                                    fn: _withId(() => [
                                      _withDirectives(_createVNode("span", _hoisted_33, [
                                        _hoisted_34
                                      ], 512), [
                                        [_vShow, _ctx.newestMemberData.deviceDatas['3']?.value.SpO2]
                                      ]),
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['3']?.value.SpO2)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_35,
                                      _hoisted_36,
                                      _withDirectives(_createVNode("span", _hoisted_37, [
                                        _hoisted_38
                                      ], 512), [
                                        [_vShow, _ctx.newestMemberData.deviceDatas['3']?.value.PR]
                                      ]),
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['3']?.value.PR)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_39,
                                      _hoisted_40,
                                      _withDirectives(_createVNode("span", _hoisted_41, [
                                        _hoisted_42
                                      ], 512), [
                                        [_vShow, _ctx.newestMemberData.deviceDatas['3']?.value.PI]
                                      ]),
                                      _createVNode("span", {
                                        textContent: _toDisplayString(_ctx.newestMemberData.deviceDatas['3']?.value.PI)
                                      }, null, 8, ["textContent"]),
                                      _hoisted_43
                                    ])
                                  }
                                : {
                                    name: "title",
                                    fn: _withId(() => [
                                      _createVNode("span", { class: "value-unit" }, "未检测")
                                    ])
                                  }
                            ]), 1024)
                          ]),
                          _: 1
                        }),
                        (_ctx.newestMemberData.deviceDatas['6'])
                          ? (_openBlock(), _createBlock(_component_van_field, {
                              key: 0,
                              readonly: "",
                              label: "备注",
                              "label-width": "3em",
                              "input-align": "left",
                              modelValue: _ctx.newestMemberData.deviceDatas['6'].value,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.newestMemberData.deviceDatas['6'].value = $event)),
                              rows: "3",
                              autosize: "",
                              type: "textarea"
                            }, null, 8, ["modelValue"]))
                          : (_openBlock(), _createBlock(_component_van_field, {
                              key: 1,
                              readonly: "",
                              label: "备注",
                              "label-width": "3em",
                              "input-align": "left",
                              rows: "3",
                              type: "textarea"
                            }))
                      ], 64))
                    : (_openBlock(), _createBlock(_component_van_empty, {
                        key: 1,
                        "image-size": "60px"
                      }, {
                        image: _withId(() => [
                          _hoisted_44
                        ]),
                        description: _withId(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_46, [
                (_ctx.activeTab === 'agencyEntry')
                  ? (_openBlock(), _createBlock(_component_van_row, {
                      key: 0,
                      gutter: "20"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_van_col, { span: "8" }, {
                          default: _withId(() => [
                            _createVNode(_component_van_button, {
                              block: "",
                              type: "default",
                              plain: "",
                              onClick: _ctx.onAgencyEntryClose
                            }, {
                              default: _withId(() => [
                                _hoisted_47
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, { span: "16" }, {
                          default: _withId(() => [
                            _createVNode(_component_van_button, {
                              block: "",
                              type: "primary",
                              "native-type": "submit",
                              color: "rgb(159, 102, 204)"
                            }, {
                              default: _withId(() => [
                                _hoisted_48
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
                      default: _withId(() => [
                        _createVNode(_component_van_col, { span: "24" }, {
                          default: _withId(() => [
                            _createVNode(_component_van_button, {
                              round: "",
                              block: "",
                              type: "primary",
                              "native-type": "submit",
                              color: "rgb(159, 102, 204)"
                            }, {
                              default: _withId(() => [
                                _hoisted_49
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]))
      : _createCommentVNode("", true)
  ]))
})